import SearchIcon from '@mui/icons-material/Search'
import { AdasSearchMenu } from '@components/wrapper-components'
import PropTypes from 'prop-types'
import { AdasBox, AdasTextField, AdasInputAdornment } from '../wrapper-components'

const SearchWithSelect = ({ selectValue, onSelectChange, searchValue, onSearchChange, options, placeholder }) => {
  return (
    <AdasBox
      display='flex'
      alignItems='center'
      sx={{
        width: { xs: '100%', md: '50%' },
        flexDirection: { xs: 'row' },
        alignItems: { xs: 'center' }
      }}
    >
      <AdasSearchMenu
        value={selectValue}
        onChange={onSelectChange}
        options={options}
        sx={{
          minWidth: { xs: '50%', sm: 140 },
          width: { xs: '50%', sm: 'auto' },
          '& .MuiInputBase-root': {
            backgroundColor: 'rgba(243, 243, 245, 1)',
            borderRadius: '8px !important',
            fontSize: '0.875rem !important',
            padding: '5px 10px',
            maxHeight: '2.5rem'
          },
          '& fieldset': {
            border: 'none'
          }
        }}
      />

      <AdasTextField
        value={searchValue}
        onChange={onSearchChange}
        placeholder={placeholder}
        variant='standard'
        InputProps={{
          disableUnderline: true,
          startAdornment: (
            <AdasInputAdornment position='start'>
              <SearchIcon sx={{ color: '#9e9e9e' }} />
            </AdasInputAdornment>
          )
        }}
        sx={{
          minWidth: { xs: '50%', sm: 200 },
          width: { xs: '50%', sm: 'auto' },
          padding: '10px',
          '& .MuiInputBase-root': {
            backgroundColor: 'rgba(243, 243, 245, 1)',
            borderRadius: '8px !important',
            fontSize: '0.875rem !important',
            padding: '5px 10px',
            maxHeight: '2.5rem'
          },
          '& fieldset': {
            border: 'none'
          }
        }}
      />
    </AdasBox>
  )
}

SearchWithSelect.propTypes = {
  selectValue: PropTypes.string,
  onSelectChange: PropTypes.func,
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string
}

export default SearchWithSelect
